import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  storeBusiness: null,
  business: null,
};
const settingSlice = createSlice({
  name: 'setting',
  initialState,

  reducers: {
    storeBusinessRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeBusinessSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeBusiness = action.payload;
    },
    storeBusinessFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    loadBusinessRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadBusinessSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.business = action.payload;
    },
    loadBusinessFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
export const {
  storeBusinessRequested,
  storeBusinessSuccess,
  storeBusinessFail,
  loadBusinessRequested,
  loadBusinessSuccess,
  loadBusinessFail,
} = settingSlice.actions;

export default settingSlice.reducer;
